<template>
    <el-form :model="formInfo" ref="formInfo" :rules="rules" label-position="right" label-width="120px">
        <el-form-item :label="$t('pgCommon.MQ_PRODUCER')" prop="mqProducer">
            <td-select v-model="formInfo.mqProducer" url="/databusserver/interfaceManager/listResourceInfoByType" keys="sSrcId" text="sName" :urlParam="mqType" requestType="POST"></td-select>
        </el-form-item>
        <el-form-item :label="$t('pgCommon.MQ_SEND_ONE_BY_ONE')" prop="oneByOne">
            <td-radio v-model="formInfo.oneByOne" :options="sendBatch" keys="id" text="name"></td-radio>
            <br>
            <span style="color: red">{{$t('pgCommon.MQ_SEND_ONE_BY_ONE_DESCRIPTION')}}</span>
        </el-form-item>
        <el-form-item :label="$t('pgCommon.MQ_SEND_USE_TEMPLATE')" prop="oneByOne">
            <td-radio v-model="formInfo.useTemplate" :options="sendBatch" keys="id" text="name" @change="templateChange()"></td-radio>
        </el-form-item>
        <el-form-item :label="$t('common.TEMPLATENAME')" v-show="formInfo.useTemplate" prop="templateSign">
            <td-select v-model="formInfo.templateSign" url="/template/getTemplateByType" keys="sSign" text="sName" :urlParam="templateType" requestType="GET"></td-select>
        </el-form-item>
    </el-form>
</template>

<script>
export default {
    props: {
        params: { type: Object }
    },
    created() {
        this.initData(JSON.parse(this.params));
    },
    data() {
        return {
            formInfo: { templateSign: '', mqProducer: '', oneByOne: true, useTemplate: true },
            templateType: { sType: 'DBTASK' },
            mqType: { iType: 0 },
            sendBatch: [{ id: true, name: '是' }, { id: false, name: '否' }],
            rules: {
                templateSign: [
                    {
                        required: true,
                        message: this.$t('pgError.ERROR_SELECT_TEMPLATE'),
                        trigger: 'blur'
                    }
                ],
                mqProducer: [
                    {
                        required: true,
                        message: this.$t('pgError.ERROR_SELECT_MQ_PRODUCER'),
                        trigger: 'blur'
                    }
                ]
            }
        };
    },
    methods: {
        initData(outputParam) {
            if (outputParam) {
                this.formInfo.templateSign = outputParam.templateSign;
                this.formInfo.mqProducer = outputParam.mqProducer;
                this.formInfo.oneByOne = outputParam.oneByOne;
                this.formInfo.useTemplate = outputParam.useTemplate;
            }
        },
        getFromInfo() {
            if (!this.formInfo.useTemplate) {
                this.formInfo.templateSign = null;
            }
            return JSON.stringify(this.formInfo);
        }
    }
};
</script>

<style scoped></style>
